<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <!-- <div v-if="successMessage" class="alert alert-success">
                    {{ successMessage }}
                </div> -->
        <div class="card shadow-lg">
          <div class="card-header bg-primary text-white">Update Subject</div>
          <div class="card-body">
            <form action="" method="post" @submit.prevent="update">
              <div class="form-group">
                <label for="name">Name</label>
                <input
                  type="text"
                  v-model="form.name"
                  id="name"
                  class="form-control"
                />
                <div v-if="theErrors.name" class="mt-2 text-danger">
                  {{ theErrors.name[0] }}
                </div>
              </div>
              <button type="submit" class="btn btn-primary">
                Update
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      form: [],
      // successMessage: "",
      subjects: [],
      theErrors: [],
    };
  },

  mounted() {
    this.getSubjects();
  },

  methods: {
    async getSubjects() {
      let response = await axios.get(`/api/subjects/${this.$route.params.id}`);
      this.form = response.data.data;
      console.log(this.form);
    },

    async update() {
      let response = await axios.patch(
        `/api/subjects/${this.$route.params.id}/edit`,
        this.form
      );
      if (response.status === 200) {
        this.$toasted.show(response.data.message, {
          type: "success",
          duration: 2000,
        });
        this.$router.push("/subjects/table");
      }
    },
  },
};
</script>
